<template>
  <div class="index-type">
    <slot name="hotBrand"></slot>
    <div class="index-coupon">
      <div
        class="item"
        v-for="(item, index) in couponList"
        :key="index"
        v-auth:click="{ method: clickCoupon, params: item }"
      >
        <div class="vh-coupons-bg" :class="{ get: item.is_client == 1 }">
          <img :src="item.brand_logo" :class="{ gray: item.is_client == 1 }" />
          <div class="vh-title">{{ item.title }}</div>
        </div>
      </div>
      <div v-show="couponMetal.total === 0" class="no-coupon">优惠券已派完~</div>
      <!-- 查看更多 -->
      <div class="index-box">
        <div class="index-more" v-show="couponList.length < couponMetal.total" @click="$emit('getCouponList')">
          <span>查看更多≫</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    couponList: {
      type: Array,
      default() {
        return [];
      },
    },
    couponMetal: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    clickCoupon(item) {
      this.$emit('clickCoupon', {
        coupon: item,
        params: {
          type: 1,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.index-type {
  height: 750px;
  padding-bottom: 30px;
  .index-coupon {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;
    .item {
      .vh-coupons-bg {
        display: flex;
        align-items: center;
        font-size: 28px;
        width: 660px;
        height: 135px;
        background: url(~@this/assets/image-13.png) no-repeat;
        background-size: 710px 301px;
        background-position: 0 0;
        padding-left: 50px;
        margin-bottom: 30px;
        color: #ffffff;
        &.get {
          background-position: 0px -168px;
          color: #ffffff;
        }
        img {
          width: 90px;
          height: 90px;
          border: 3px solid #646eac;
          border-radius: 50%;
          &.gray {
            border: 3px solid #909090;
          }
        }
        .vh-title {
          width: 304px;
          margin-left: 30px;
        }
      }
    }
    .no-coupon {
      text-align: center;
      font-size: 35px;
      color: #205453;
      font-weight: 800;
      padding-top: 10px;
    }
    .index-box {
      width: 100%;
      display: flex;
      justify-content: center;
      .index-more {
        color: #205453;
        font-weight: 800;
      }
    }
  }
}
</style>
